<template>
  <div>
    <div class="panel__header">
      <div class="grid-x">
        <div class="cell auto">
          <h3 class="panel__title">Top Earning</h3>
        </div>

        <!--
        <div class="cell shrink">
          <div class="select-field">
            <select @change="changeDateRange($event)">
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="last_7">Last 7 days</option>
              <option value="last_28" selected="selected">Last 28 days</option>
              <option value="last_90">Last 90 days</option>
              <option value="this_month">This month</option>
              <option value="last_month">Last month</option>
              <option value="this_year">This year</option>
              <option value="last_year">Last year</option>
            </select>

            <i class="fas fa-sort"></i>
          </div>
        </div>
        -->
      </div>
    </div>

    <div class="no-padding">
      <div :class="['loading-area', loading ? 'loading' : '']">
        <div :class="['loading-area__content', loading ? 'loading' : '']">
          <tableList :header="tableHeader" :data="tableData" :loading="loading"
                     @sort="orderBy" @post="go"></tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableList from '@/globals/tableList'
import paginationUtils from '@/mixins/paginationUtils'

export default {
  components: {
    tableList
  },
  mixins: [paginationUtils],
  data: function () {
    return {
      action: '/vendors/commission-totals/top_earners/',
      sort: '-earned',
      limit: 5,
      dateRange: 'last_28',
      tableHeader: {
        currentSort: 'name',
        data: [
          {
            label: 'Vendor',
            class: 'full'
          },
          {
            label: 'Due'
          },
          {
            label: 'Paid'
          },
          {
            label: 'Earned'
          }
          // {
          //   label: 'Items Sold',
          //   class: 'show-for-large'
          // }
        ]
      },
      tableData: []
    }
  },
  methods: {
    go: function (id) {
      this.$router.push('/vendors/' + id)
    },
    buildTable () {
      for (let i = 0; i < this.data.length; i++) {
        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image table-list__image--rounded">'

        if (!this.isEmpty(this.data[i].image) && this.data[i].image !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + this.data[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-user"></i></div>'
        }

        primary += '</div></div><div class="cell auto"><span class="text-overflow">' + this.data[i].name + '</span>'

        primary += '</div></div>'

        this.tableData.push({
          post: this.data[i].id,
          data: [
            {
              value: primary,
              class: 'full focus-text'
            },
            {
              value: this.formatMoney(this.data[i].commission_due) + '<span class="hide-for-medium"> due</span>'
            },
            {
              value: this.formatMoney(this.data[i].commission_paid),
              class: 'show-for-medium'
            },
            {
              value: this.formatMoney(this.data[i].commission_earned),
              class: 'show-for-large'
            }
            // {
            //   value: this.data[i].amount_sold,
            //   class: 'show-for-large'
            // }
          ]
        })
      }
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendors/sections/topEarners.vue